import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import {
  Layout,
  PostCard,
  PricingPage,
  CorporateImplementationGuide,
  GuideImplementationCarousel,
  CorporateWellnessGuide,
  ContestandChallenges,
  ActivityTracker,
  FitnessRewards,
  Faq,
  FeaturesHrDashboard,
  RequestDemo,
  ContactUs,
  GlobalWalkathonCampaign,
  LeadGenCampaign,
  Leaderboard,
  SevenMinuteWorkout,
  OfferForm,
  Casestudy,
  VirtualMarathonGuide,
  VirtualMarathonCarousel,
  HighlightedNews,
  GlobalCorporateVirtualWalkathon,
  WebcastRegistration,
  VantageFitWebcastLive,
  // WellbeingCommunity,
  // WellnessChallenges,
  // WellnessPrograms,
  // RewardsRecognition,
  Partners,
  Partnership,
  ProductUpdates,
  DIWellnessGuide,
  AZWellnessGuide,
  WFHWellnessGuide,
  FinancialWellnessGuide,
  MultiActivityChallenges,
  StepsChallenge,
  TeamChallenges,
  RemoteTeamWellness,
  GlobalEmployeeEngagement,
  MentalHealthChallenges,
  HolisticWellnessProgram,
  WellnessRewardsProgram,
  HealthFitnessAnalytics,
  HealthyNewYear,
  EmployeeWellness,
  EmployeeWellnessV1,
  AboutUs,
  AppDownload,
  EmpWellnessCalendar,
  EmployeeWellnessPmp,
  RefferVantageFit,
  VantagefitWellnessCampaigns,
  VirtualMarathon,
  WellnessLeagues,
  UltimateBuyersGuide,
  GEmployeeWellnessPlatform,
  PersonalizedProgram,
} from '../components/common'
import { News, Glossary } from '../components/common'
// import { MetaData } from "../components/common/meta";
import { LayoutMeta } from '../components/common/meta'
// import PreviousWalkathon from "../components/common/PreviousWalkathon";
// import GlobalWalkathon2022 from "../components/common/GlobalWalkathon2022";
import SponsorRegistration from '../components/common/SponsorRegistration'
import ContestGuidelines from '../components/common/ContestGuidelines'
import GCWAboutUs from '../components/common/GCWAboutUs'
import GCWThankYou from '../components/common/GCWThankYou'
import SlackIntegration from '../components/common/SlackIntegration'
import AOS from 'aos'
import 'aos/dist/aos.css'
import CountUp from 'react-countup'
import CountdownTimer from '../components/CountdownTimer'
import url from 'url'
import config from '../utils/siteConfig'
import { getJsonLDData } from '../utils/jsonLDDataAll'

/**
 * Single page (/:slug)
 *
 * This file renders a single page and loads all the content.
 *
 */

export function Head({ data, location }) {
  const page = data.ghostPage
  const canonical = url.resolve(config.siteUrl, location.pathname)
  const jsonLD = getJsonLDData(location.pathname)
  // if (!jsonLD) {
  //   return null
  // }
  return (
    <>
      {/* <MetaData location={location} /> */}
      <LayoutMeta />
      <link rel="canonical" href={canonical} />
      <title>{page.meta_title}</title>
      <meta name="description" content={page.meta_description} />
      <meta property="og:site_name" content="Vantage Fit" />
      <meta property="og:title" content={page.meta_title} />
      <meta property="og:description" content={page.meta_description} />
      <meta name="twitter:title" content={page.meta_title} />
      <meta name="twitter:description" content={page.meta_description} />
      {/* {jsonLD && (<script type="application/ld+json">{JSON.stringify(jsonLD)}</script>)} */}
      {/* {(location.pathname === `/about-us/` || location.pathname === `/contact-us/`) && (
        <script type="application/ld+json">{JSON.stringify(jsonLD)}</script>
      )} */}
      {jsonLD ? <script type="application/ld+json">{JSON.stringify(jsonLD)}</script> : null}
    </>
  )
}

const Page = ({ data, location }) => {
  const posts = data.allGhostPost.edges
  const page = data.ghostPage

  return (
    <>
      <Layout>
        <div className="elementor">
          <div className="elementor-inner">
            <div className="elementor-section-wrap"></div>
            {location.pathname !== `/resources/` || location.pathname !== `/resources` ? (
              <section
                className="content-body load-external-scripts "
                dangerouslySetInnerHTML={{ __html: page.html }}
              />
            ) : null}
          </div>
        </div>
        {location.pathname === `/resources/` || location.pathname === `/resources` ? (
          <div className="main-content">
            <section>
              <div className="container custom-container">
                <div className="row">
                  {posts.map(({ node }) => (
                    <PostCard key={node.id} post={node} />
                  ))}
                </div>
              </div>
            </section>
          </div>
        ) : null}
        {location.pathname === `/pricing` ||
        location.pathname === `/pricing/` ||
        location.pathname === `/fr/tarification` ||
        location.pathname === `/fr/tarification/` ||
        location.pathname === `/es/precios` ||
        location.pathname === `/es/precios/` ||
        location.pathname === `/de/preise` ||
        location.pathname === `/de/preise/` ? (
          <PricingPage />
        ) : null}
        {location.pathname === `/about-us` ||
        location.pathname === `/about-us/` ||
        location.pathname === `/fr/a-propos-de-nous` ||
        location.pathname === `/fr/a-propos-de-nous/` ||
        location.pathname === `/es/sobre-nosotros` ||
        location.pathname === `/es/sobre-nosotros/` ||
        location.pathname === `/de/uber-uns` ||
        location.pathname === `/de/uber-uns/` ? (
          <AboutUs />
        ) : null}
        {location.pathname === `/vantage-fit-implementation-guide` ||
        location.pathname === `/vantage-fit-implementation-guide/` ? (
          <CorporateWellnessGuide />
        ) : null}
        {location.pathname === `/vantagefit-corporate-wellness-guide` ||
        location.pathname === `/vantagefit-corporate-wellness-guide/` ? (
          <CorporateImplementationGuide />
        ) : null}
        {location.pathname === `/contest-and-challenges` || location.pathname === `/contest-and-challenges/` ? (
          <ContestandChallenges />
        ) : null}
        {location.pathname === `/activity-tracker` || location.pathname === `/activity-tracker/` ? (
          <ActivityTracker />
        ) : null}
        {location.pathname === `/fitness-rewards` || location.pathname === `/fitness-rewards/` ? (
          <FitnessRewards />
        ) : null}
        {location.pathname === `/faq` ||
        location.pathname === `/faq/` ||
        location.pathname === `/fr/faq` ||
        location.pathname === `/fr/faq/` ||
        location.pathname === `/es/faq` ||
        location.pathname === `/es/faq/` ||
        location.pathname === `/de/faq` ||
        location.pathname === `/de/faq/` ? (
          <Faq />
        ) : null}
        {location.pathname === `/hr-admin-dashboard` || location.pathname === `/hr-admin-dashboard/` ? (
          <FeaturesHrDashboard />
        ) : null}
        {location.pathname === `/request-demo` ||
        location.pathname === `/request-demo/` ||
        location.pathname === `/fr/planifier-demo` ||
        location.pathname === `/fr/planifier-demo/` ||
        location.pathname === `/es/solicita-una-demo` ||
        location.pathname === `/es/solicita-una-demo/` ||
        location.pathname === `/de/demo-anfordern` ||
        location.pathname === `/de/demo-anfordern/` ? (
          <RequestDemo />
        ) : null}
        {location.pathname === `/contact-us` ||
        location.pathname === `/contact-us/` ||
        location.pathname === `/fr/contactez-nous` ||
        location.pathname === `/fr/contactez-nous/` ||
        location.pathname === `/es/contacta-con-nosotros` ||
        location.pathname === `/es/contacta-con-nosotros/` ||
        location.pathname === `/de/kontaktieren-sie-uns` ||
        location.pathname === `/de/kontaktieren-sie-uns/` ? (
          <ContactUs />
        ) : null}
        {location.pathname === `/global-corporate-virtual-walkathon` ||
        location.pathname === `/global-corporate-virtual-walkathon/` ? (
          <GlobalWalkathonCampaign />
        ) : null}

        {/* {location.pathname === '/global-corporate-virtual-walkathon' || location.pathname === '/global-corporate-virtual-walkathon/'
                || location.pathname === '/global-corporate-virtual-walkathon-v2' || location.pathname === '/global-corporate-virtual-walkathon-v2/'
                 || location.pathname === '/global-corporate-virtual-walkathon-v3' || location.pathname === '/global-corporate-virtual-walkathon-v3/'
                 || location.pathname === '/global-corporate-virtual-walkathon-v4' || location.pathname === '/global-corporate-virtual-walkathon-v4/' ?
                    <GlobalWalkathonCampaign />: null
                } */}

        {location.pathname === `/sponsor-registration-global-corporate-virtual-walkathon` ||
        location.pathname === `/sponsor-registration-global-corporate-virtual-walkathon/` ? (
          <SponsorRegistration />
        ) : null}
        {/* {
                   location.pathname === '/contest-guidelines' ? <ContestGuidelines />: null
                } */}
        {location.pathname === `/employee-wellness-program` || location.pathname === `/employee-wellness-program/` ? (
          <LeadGenCampaign />
        ) : null}

        {/* {location.pathname === `/leaderboard` || location.pathname === `/leaderboard/` ?
                    <Leaderboard/> : null
                } */}
        {location.pathname === `/a-detailed-guide-to-the-7-minute-workout` ||
        location.pathname === `/a-detailed-guide-to-the-7-minute-workout/` ? (
          <SevenMinuteWorkout />
        ) : null}
        {location.pathname === `/exclusive-corporate-offer` || location.pathname === `/exclusive-corporate-offer/` ? (
          <OfferForm />
        ) : null}
        {location.pathname === `/casestudy` || location.pathname === `/casestudy/` ? <Casestudy /> : null}
        {location.pathname === `/product-updates` || location.pathname === `/product-updates/` ? (
          <ProductUpdates />
        ) : null}
        {location.pathname === `/the-step-by-step-virtual-marathon-guide` ||
        location.pathname === `/the-step-by-step-virtual-marathon-guide/` ? (
          <VirtualMarathonGuide />
        ) : null}

        {location.pathname === `/in-the-news` || location.pathname === `/in-the-news/` ? <News /> : null}
        {location.pathname === `/corporate-wellness-glossary` ||
        location.pathname === `/corporate-wellness-glossary/` ? (
          <Glossary />
        ) : null}
        {/* {location.pathname ===
                    `/global-corporate-virtual-walkathon-2021` ||
                location.pathname ===
                    `/global-corporate-virtual-walkathon-2021/` ? (
                    <PreviousWalkathon />
                ) : null}
                {location.pathname ===
                    `/global-corporate-virtual-walkathon-2022` ||
                location.pathname ===
                    `/global-corporate-virtual-walkathon-2022/` ? (
                    <GlobalWalkathon2022 />
                ) : null} */}
        {location.pathname === `/contest-guidelines-global-corporate-virtual-walkathon` ||
        location.pathname === `/contest-guidelines-global-corporate-virtual-walkathon/` ? (
          <ContestGuidelines />
        ) : null}
        {location.pathname === `/about-us-global-corporate-virtual-walkathon/` ||
        location.pathname === `/about-us-global-corporate-virtual-walkathon//` ? (
          <GCWAboutUs />
        ) : null}
        {location.pathname === `/registration-thank-you-global-corporate-virtual-walkathon` ||
        location.pathname === `/registration-thank-you-global-corporate-virtual-walkathon/` ? (
          <GCWThankYou />
        ) : null}

        {location.pathname === `/vantage-fit-webcast-registration` ||
        location.pathname === `/vantage-fit-webcast-registration/` ? (
          <WebcastRegistration />
        ) : null}
        {location.pathname === `/vantage-fit-webcast-live` || location.pathname === `/vantage-fit-webcast-live/` ? (
          <VantageFitWebcastLive />
        ) : null}
        {location.pathname === `/partners` ||
        location.pathname === `/partners/` ||
        location.pathname === `/fr/partenaire-avec-nous` ||
        location.pathname === `/fr/partenaire-avec-nous/` ||
        location.pathname === `/es/socios` ||
        location.pathname === `/es/socios/` ||
        location.pathname === `/de/partner` ||
        location.pathname === `/de/partner/` ? (
          <Partners />
        ) : null}
        {location.pathname === `/partnership` ||
        location.pathname === `/partnership/` ||
        location.pathname === `/fr/partenariat` ||
        location.pathname === `/fr/partenariat/` ||
        location.pathname === `/es/colaboracion` ||
        location.pathname === `/es/colaboracion/` ||
        location.pathname === `/de/partnerschaft` ||
        location.pathname === `/de/partnerschaft/` ? (
          <Partnership />
        ) : null}
        {/* {location.pathname === `/product-updates` || location.pathname === `/product-updates/` ? (
          <ProductUpdates />
        ) : null} */}
        {location.pathname === `/intergrating-d-and-i-wellness-guide-with-vantage-fit` ||
        location.pathname === `/intergrating-d-and-i-wellness-guide-with-vantage-fit/` ? (
          <DIWellnessGuide />
        ) : null}
        {location.pathname === `/a-z-wellness-challenge-ideas-guide` ||
        location.pathname === `/a-z-wellness-challenge-ideas-guide/` ? (
          <AZWellnessGuide />
        ) : null}
        {location.pathname === `/incorporating-work-from-home-wellness-with-vantage-fit` ||
        location.pathname === `/incorporating-work-from-home-wellness-with-vantage-fit/` ? (
          <WFHWellnessGuide />
        ) : null}
        {location.pathname === `/the-ultimate-guide-for-employee-wellness-calendar` ||
        location.pathname === `/the-ultimate-guide-for-employee-wellness-calendar/` ? (
          <EmpWellnessCalendar />
        ) : null}
        {location.pathname === `/implementing-financial-wellness-with-vantage-fit` ||
        location.pathname === `/implementing-financial-wellness-with-vantage-fit/` ? (
          <FinancialWellnessGuide />
        ) : null}
        {location.pathname === `/multi-activity-challenges` ||
        location.pathname === `/multi-activity-challenges/` ||
        location.pathname === `/fr/defis-multi-activites` ||
        location.pathname === `/fr/defis-multi-activites/` ||
        location.pathname === `/es/desafios-multi-actividades` ||
        location.pathname === `/es/desafios-multi-actividades/` ||
        location.pathname === `/de/multi-aktivitats-herausforderungen` ||
        location.pathname === `/de/multi-aktivitats-herausforderungen/` ? (
          <MultiActivityChallenges />
        ) : null}
        {location.pathname === `/steps-challenge` ||
        location.pathname === `/steps-challenge/` ||
        location.pathname === `/fr/etapes-defi` ||
        location.pathname === `/fr/etapes-defi/` ||
        location.pathname === `/es/desafio-de-pasos` ||
        location.pathname === `/es/desafio-de-pasos/` ||
        location.pathname === `/de/schritt-herausforderung` ||
        location.pathname === `/de/schritt-herausforderung/` ? (
          <StepsChallenge />
        ) : null}
        {location.pathname === `/team-challenges` ||
        location.pathname === `/team-challenges/` ||
        location.pathname === `/fr/defi-dequipe` ||
        location.pathname === `/fr/defi-dequipe/` ||
        location.pathname === `/es/desafio-de-equipo` ||
        location.pathname === `/es/desafio-de-equipo/` ||
        location.pathname === `/de/team-herausforderung` ||
        location.pathname === `/de/team-herausforderung/` ? (
          <TeamChallenges />
        ) : null}
        {location.pathname === `/remote-team-wellness` ||
        location.pathname === `/remote-team-wellness/` ||
        location.pathname === `/fr/bien-etre-de-lequipe-a-distance` ||
        location.pathname === `/fr/bien-etre-de-lequipe-a-distance/` ||
        location.pathname === `/es/bienestar-del-equipo-remoto` ||
        location.pathname === `/es/bienestar-del-equipo-remoto/` ||
        location.pathname === `/de/wellness-fur-remote-teams` ||
        location.pathname === `/de/wellness-fur-remote-teams/` ? (
          <RemoteTeamWellness />
        ) : null}
        {location.pathname === `/global-employee-engagement` ||
        location.pathname === `/global-employee-engagement/` ||
        location.pathname === `/fr/engagement-mondial-des-employes` ||
        location.pathname === `/fr/engagement-mondial-des-employes/` ||
        location.pathname === `/es/compromiso-global-de-empleados` ||
        location.pathname === `/es/compromiso-global-de-empleados/` ||
        location.pathname === `/de/globales-mitarbeiterengagement` ||
        location.pathname === `/de/globales-mitarbeiterengagement/` ? (
          <GlobalEmployeeEngagement />
        ) : null}
        {location.pathname === `/mental-health-and-wellbeing-challenges` ||
        location.pathname === `/mental-health-and-wellbeing-challenges/` ||
        location.pathname === `/fr/sante-mentale-et-bien-etre` ||
        location.pathname === `/fr/sante-mentale-et-bien-etre/` ||
        location.pathname === `/es/salud-mental-y-bienestar` ||
        location.pathname === `/es/salud-mental-y-bienestar/` ||
        location.pathname === `/de/mentale-gesundheit-und-wellbeing` ||
        location.pathname === `/de/mentale-gesundheit-und-wellbeing/` ? (
          <MentalHealthChallenges />
        ) : null}
        {location.pathname === `/holistic-wellness-program` ||
        location.pathname === `/holistic-wellness-program/` ||
        location.pathname === `/fr/programme-de-mieux-etre-holistique` ||
        location.pathname === `/fr/programme-de-mieux-etre-holistique/` ||
        location.pathname === `/es/programa-de-bienestar-holistico` ||
        location.pathname === `/es/programa-de-bienestar-holistico/` ||
        location.pathname === `/de/ganzheitliches-wellness-programm` ||
        location.pathname === `/de/ganzheitliches-wellness-programm/` ? (
          <HolisticWellnessProgram />
        ) : null}
        {location.pathname === `/wellness-rewards-program` ||
        location.pathname === `/wellness-rewards-program/` ||
        location.pathname === `/fr/programme-de-recompenses-pour-le-mieux-etre` ||
        location.pathname === `/fr/programme-de-recompenses-pour-le-mieux-etre/` ||
        location.pathname === `/es/programa-de-recompensas-para-el-bienestar` ||
        location.pathname === `/es/programa-de-recompensas-para-el-bienestar/` ||
        location.pathname === `/de/wellness-belohnungsprogramm` ||
        location.pathname === `/de/wellness-belohnungsprogramm/` ? (
          <WellnessRewardsProgram />
        ) : null}
        {location.pathname === `/health-fitness-analytics` ||
        location.pathname === `/health-fitness-analytics/` ||
        location.pathname === `/fr/analyses-de-la-sante-et-de-la-condition-physique` ||
        location.pathname === `/fr/analyses-de-la-sante-et-de-la-condition-physique/` ||
        location.pathname === `/es/analisis-de-salud-y-condicion-fisica` ||
        location.pathname === `/es/analisis-de-salud-y-condicion-fisica/` ||
        location.pathname === `/de/gesundheits-und-fitnessanalyse` ||
        location.pathname === `/de/gesundheits-und-fitnessanalyse/` ? (
          <HealthFitnessAnalytics />
        ) : null}
        {location.pathname === `/healthy-new-year` || location.pathname === `/healthy-new-year/` ? (
          <HealthyNewYear />
        ) : null}
        {location.pathname === `/employee-wellness` || location.pathname === `/employee-wellness/` ? (
          <EmployeeWellness />
        ) : null}
        {location.pathname === `/global-employee-wellness-platform` ||
        location.pathname === `/global-employee-wellness-platform/` ? (
          <GEmployeeWellnessPlatform />
        ) : null}
        {location.pathname === `/employee-wellness-v1` || location.pathname === `/employee-wellness-v1/` ? (
          <EmployeeWellnessV1 />
        ) : null}
        {location.pathname === `/employee-wellness-pmp` || location.pathname === `/employee-wellness-pmp/` ? (
          <EmployeeWellnessPmp />
        ) : null}
        {location.pathname === `/slack-integration` ||
        location.pathname === `/slack-integration/` ||
        location.pathname === `/fr/integration-slack` ||
        location.pathname === `/fr/integration-slack/` ? (
          <SlackIntegration />
        ) : null}
        {location.pathname === `/app-download` ||
        location.pathname === `/app-download/` ||
        location.pathname === `/fr/telechargement-de-lapplication` ||
        location.pathname === `/fr/telechargement-de-lapplication/` ||
        location.pathname === `/es/descargar-aplicacion` ||
        location.pathname === `/es/descargar-aplicacion/` ||
        location.pathname === `/de/app-herunterladen` ||
        location.pathname === `/de/app-herunterladen/` ? (
          <AppDownload />
        ) : null}
        {location.pathname === `/refer-vantage-fit` || location.pathname === `/refer-vantage-fit/` ? (
          <RefferVantageFit />
        ) : null}
        {location.pathname === `/vantagefit-wellness-campaigns/` ? <VantagefitWellnessCampaigns /> : null}
        {location.pathname === `/virtual-marathon` ||
        location.pathname === `/virtual-marathon/` ||
        location.pathname === `/fr/marathon-virtuel` ||
        location.pathname === `/fr/marathon-virtuel/` ||
        location.pathname === `/es/maraton-virtual` ||
        location.pathname === `/es/maraton-virtual/` ||
        location.pathname === `/de/virtueller-marathon` ||
        location.pathname === `/de/virtueller-marathon/` ? (
          <VirtualMarathon />
        ) : null}

        {location.pathname === `/the-ultimate-buyers-guide-to-corporate-wellness-programs` ||
        location.pathname === `/the-ultimate-buyers-guide-to-corporate-wellness-programs/` ? (
          <UltimateBuyersGuide />
        ) : null}
      </Layout>
    </>
  )
}

Page.propTypes = {
  data: PropTypes.shape({
    ghostPage: PropTypes.shape({
      codeinjection_styles: PropTypes.object,
      title: PropTypes.string.isRequired,
      html: PropTypes.string,
      feature_image: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.object.isRequired,
}

export default Page

export const postQuery = graphql`
  query ($slug: String!) {
    ghostPage(slug: { eq: $slug }) {
      ...GhostPageFields
    }
    allGhostPost(
      sort: { published_at: DESC }
      filter: { tags: { elemMatch: { name: { eq: "#Resources", nin: ["#de-r", "#es-r", "#fr-r"] } } } }
    ) {
      edges {
        node {
          ...GhostPostFields
        }
      }
    }
    locales: allLocale(
      filter: { ns: { in: ["new_trans", "translation", "images"] }, language: { in: ["fr", "es", "de"] } }
    ) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
